import { Livewire, Alpine } from '../../../../../../../../vendor/livewire/livewire/dist/livewire.esm';
import Clipboard from '@ryangjchandler/alpine-clipboard'

Alpine.plugin(Clipboard)
Livewire.start()

// Swiper
import {Swiper, Navigation, Pagination, Thumbs} from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
window.Swiper = Swiper

import './utils/accordion';
import './utils/modal';
import './utils/fullscreen-sidebar'

// Lazyload
import lazySizes from 'lazysizes';

// Swal
import Swal from 'sweetalert2';
window.Swal = Swal;
window.Toast = Swal.mixin({
    toast: true,
    position: 'top-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast'
    },
    showConfirmButton: false,
    timer: 3330,
    timerProgressBar: true
});

// LightGallery
import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';
import 'lightgallery/css/lightgallery-bundle.css';

lightGallery(document.getElementById('videos-light-gallery'), {
    plugins: [lgVideo],
});

// LightBox
import SimpleLightbox from "simplelightbox";
import 'simplelightbox/dist/simple-lightbox.min.css';

var lightbox = new SimpleLightbox('.gallery-lightbox a', {
    rtl: true,
    overlayOpacity: .8,
});
window.lightbox = lightbox;

// fslightbox
import FsLightbox from "fslightbox";

import Plyr from 'plyr';
import 'plyr/src/sass/plyr.scss'

// Fancybox
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";
const setupApp = ()=>
{
    const player = new Plyr('#player', {
        ratio: '16:9'
    });

    lazySizes.init();

    lightbox.refresh();
    refreshFsLightbox();

    // Fancybox
    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });

    // VideoJS
    // TODO

    const qualitiesSwiper = new Swiper('.qualities-swiper-container', {
        direction: 'horizontal',
        loop: true,
        slidesPerView:'1.4',
        // slidesOffsetAfter:100,
        spaceBetween:30,
        centeredSlidesBounds:true,
        centeredSlides:true,
        clickable:"true",
        breakpoints:{
            768:{
                slidesPerView: 2.2,
            },
            1280:{
                enabled:false,
                slidesPerView: 4,
                slidesOffsetAfter:0,
                spaceBetween:20,
                centeredSlides: true,
                centeredSlidesBounds: true,
                loop:false,
                clickable:false,
                allowSlideNext:false,
                allowSlidePrev:false,
            },
        }

    });


    const shopSwiper = new Swiper('.shop-swiper-container', {
        direction: 'horizontal',
        slidesPerView: 1.2,
        // freeMode:true,
        clickable: "true",
        slidesOffsetAfter:120,
        breakpoints: {
            768:{
                slidesPerView: 2.2,
            },
            1289:{
                slidesPerView:4.4,
            },
        }
    });

    const schoolSwiper = new Swiper('.school-swiper-container', {
        direction: 'horizontal',
        slidesPerView: 1.1,
        clickable:"true",
        breakpoints:{
            768:{
                slidesPerView: 1.9,
            },
            1289:{
                slidesPerView:4.1,
            },
        }
    });

    const blogSwiper = new Swiper('.blog-swiper-container', {
        direction: 'horizontal',
        slidesPerView: 1.08,
        clickable:"true",
        breakpoints:{
            768:{
                slidesPerView: 1.7,
            },
            1289:{
                slidesPerView:4.7,
            },
        }
    });


    const coursesMainSlideshow = new Swiper('.main-slideshow-swiper-container', {

        loop: true,

        pagination: {
            el: ".swiper-pagination",
            type: "progressbar",
            progressbarFillClass: 'my-swiper-pagination-progressbar-fill',
        },
        speed: 1000,
        autoplay: {
            delay: 3000,
            pauseOnMouseEnter: true,
            disableOnInteraction: false,
        },



        breakpoints: {
            1028: {

                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },

            }

        }

    });


    const schoolIndexAdvantagesSwiper = new Swiper('.school-index-advantages-swiper-container', {
        direction: 'horizontal',
        slidesPerView: 2.1,
        clickable:"true",
        breakpoints:{
            768:{
                slidesPerView: 2.2,
                loop: true,
            },
            1280:{
                slidesPerView: 4,
                slidesOffsetAfter:0,
                spaceBetween:20,
                centeredSlides: true,
                centeredSlidesBounds: true,
                loop:false,
                clickable:false,
                allowSlideNext:false,
                allowSlidePrev:false,
            },
        }

    });

    const coursesCategoryCardsSwiper = new Swiper('.school-index-courses-category-cards-swiper-container',  {
        direction: 'horizontal',
        slidesPerView: 1.1,
        clickable:"true",
        breakpoints:{
            768:{
                slidesPerView: 1.9,
            },
            1024: {
                slidesPerView:2.9,
            },
            1280:{
                slidesPerView:4.1,
            },
        }
    });


    const featuredCoursesIndexCardsSwiper = new Swiper('.featured-courses-index-courses-cards-swiper-container', {
        direction: 'horizontal',
        slidesPerView: 1.2,
        clickable:"true",
        breakpoints:{
            768:{
                slidesPerView: 1.9,
            },
            1024: {
                slidesPerView: 2.9,
                // centeredSlides: true,
                // centeredSlidesBounds: true,
            },
            1248: {
                slidesPerView: 4,
                slidesOffsetAfter:0,
                spaceBetween:20,
                loop:false,
                clickable:false,
                allowSlideNext:false,
                allowSlidePrev:false,
            }

        }
    });


    const featuredProductsIndexCardsSwiper = new Swiper('.featured-products-index-swiper-container', {
        direction: 'horizontal',
        slidesPerView: 1.2,
        clickable:"true",
        breakpoints:{
            768:{
                slidesPerView: 1.9,
            },
            1024: {
                slidesPerView: 2.9,
                // centeredSlides: true,
                // centeredSlidesBounds: true,
            },
            1248: {
                slidesPerView: 4,
                slidesOffsetAfter:0,
                spaceBetween:20,
                loop:false,
                clickable:false,
                allowSlideNext:false,
                allowSlidePrev:false,
            }

        }
    });



    const productGalleryThumb = new Swiper('.product-thumb-imgs-swiper-container', {
        modules: [Navigation],
        direction: 'horizontal',
        spaceBetween: 10,
        slidesPerView: 3,
        breakpoints: {
            768:{
                slidesPerView: 4,
            },
        },
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });

    const productGallery = new Swiper('.product-imgs-swiper-container', {
        modules: [Navigation, Thumbs],
        direction: 'horizontal',
        centeredSlides:true,
        centeredSlidesBounds:true,
        slidesPerView:1,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        spaceBetween: 10,
        thumbs: {
            swiper : productGalleryThumb
        },
    });

    const blogHeroSwiper = new Swiper('.blog-hero-swiper-container', {
        direction: 'horizontal',
        slidesPerView: 1.05,
        spaceBetween: 10,
        freeMode:true,
        clickable: "true",
        slidesOffsetAfter:20,
        breakpoints: {
            768:{
                slidesPerView: 1.6,
            },
            1024: {
                slidesPerView: 2.3
            },
            1280:{
                enabled: false,
                slidesPerView:'auto',
            },
        }

    });

    const shopHeroSwiper = new Swiper('.shop-hero-swiper-container', {
        direction: 'horizontal',
        slidesPerView: 1.05,
        spaceBetween: 10,
        freeMode:true,
        clickable: "true",
        slidesOffsetAfter: 20,
        pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
        },
        breakpoints: {
            768:{
                slidesPerView: 1.6,
            },
            1024: {
                slidesPerView: 2.3
            },
            1280:{
                slidesPerView:1,
            },
        }

    });

    let productRelatedItems = new Swiper('.product-related-items',  {
        slidesPerView: 1.2,
        spaceBetween: 15,
        breakpoints:{
            768:{
                slidesPerView: 2.3,
            },
            1024: {
                slidesPerView:3.3,
            },
            1280:{
                slidesPerView:4.3,
            },
        }
    });

};


["livewire:initialized", "livewire:navigated", "resize", "pageChanged"].forEach((event) => {
    window.addEventListener(event, setupApp)
})

window.addEventListener("livewire:navigated", function(){
    window.scrollTo({top: 0, behavior: 'smooth'});
})


// console.clear();
